import React from 'react';
import FormAttachment from "../../../../library/form/components/FormAttachment"
import FormROValue from "../../../../library/form/components/FormROValue1"
import SarasTrans from "../../../../library/notifications/SarasTrans";
import FormWrapper from "../../../../library/form/components/FormWrapper"
import ItemForecast from "../../item/components/ItemForecast";
import useFormApi from "../../../cmn/docAutomation/useFormApi"

const ListChoicesItemContentRow = (props) => {

    const { formObject, rowKey, viewData } = props;
    const [popupName, setPopupName] = React.useState("");
    const [popupData, setPopupData] = React.useState(null);
    const cellRef = React.useRef();
    let formApi = useFormApi();

    if (!viewData)
        return (null)

    const data = viewData.rowValues;

    const loadPopupData = () => {
        let customAction = {
            actionId: "show",
            actionName: "itemForecast",
            actionParam: {
                actionType: "",
                showPopup: "1",
                dtId: data.forcastContainer.dataList.valLDT,
                dId: data.forcastContainer.val,
            },
            containerKey: "custom",
            onSuccess: onSuccess
        };

        formApi.runGenericAction(customAction, "itemForecast", viewData, null, null, "", "DashViews", 0, onSuccess);
    }

    const onSuccess = (action, containerKey, rowKey, headerKey, response) => {
        setPopupData(response.mainViewData);
    }

    const showPopup = () => {
        setPopupName("fc");
        
        if(!popupData){
            loadPopupData();
        }
    }

    const hidePopup = () => {
        setPopupName("");
    }

    const renderPopup = () => {
        if(popupName === "fc" && popupData){
            return(
                <ItemForecast viewData={popupData} anchorRef={cellRef} />
            )
        }

        return null;
    }

    return (
        <>
            <div className="uiBlock uiContentCenter">
                <FormROValue format="#" formObject={formObject} className="uiSpacerH5" rowKey={rowKey} action={{ paramName: "svCode" }} />
            </div>

            <div style={{ margin: "3px auto", width: "100%", backgroundColor: "#fff", textAlign: "center", minHeight: "60px" }}>
                <FormAttachment style={{ cursor: "pointer", maxWidth: "50%", maxHeight: "60px" }} 
                    formObject={formObject} rowKey={rowKey} action={{ InputType: "i", paramName: "designImage" }} />
            </div>

            <FormROValue style={{ height: "30px", fontSize: "11px", overflow:"hidden" }} className="uiBlock uiHighlightText" format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "designName" }} />

            <span className="uiBlock uiLeftAlignText" style={{ height: "30px", fontSize: "11px" }}>
                <span className='uiSpacerH5'><SarasTrans value="SIH" /></span><FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "qty" }} />

                <FormWrapper wrapperClass="uiLink" wrapperStyle={{ width: "30px", marginTop: "3px", marginLeft: "10px" }}
                    customWrapper="span" formObject={formObject} rowKey="" action={{ paramName: "forcastContainer" }} >
                    <span ref={cellRef} onMouseOver={showPopup} onMouseLeave={hidePopup} title="Pending Movement" >
                        <FormROValue style={{ color: "green" }} format="#"
                            formObject={formObject} rowKey={rowKey} action={{ paramName: "valfcIn" }}
                        />
                        <FormROValue style={{ color: "red" }} format="#"
                            formObject={formObject} rowKey={rowKey} action={{ paramName: "valfcOut" }}
                        />
                        {renderPopup()}
                    </span>
                </FormWrapper>
            </span>

            <FormROValue style={{ height: "30px", fontSize: "11px" }} className="uiBlock uiLeftAlignText" format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "addInfo" }} />
        </>
    )
}

export default ListChoicesItemContentRow